export default "__VITE_ASSET__CEpapqVh__"